export default function PlanMyTrip() {
  return (
    <div className="space-y-10 text-gray-700 leading-relaxed">
      {/* Intro */}
      <section>
        <p className="text-lg">
          Planning a Himalayan trek requires careful preparation. Below is a
          comprehensive guide curated by our Nepal-based trekking experts to
          help you trek safely, comfortably, and confidently.
        </p>
      </section>

      {/* Clothing */}
      <section>
        <h3 className="text-xl font-semibold mb-4">🧥 Clothing Essentials</h3>
        <ul className="list-disc pl-6 space-y-2">
          <li>Waterproof down jacket (−10°C to −20°C rated)</li>
          <li>Thermal base layers (top & bottom)</li>
          <li>Fleece or insulated mid-layer</li>
          <li>Waterproof trekking pants</li>
          <li>UV-protection trekking shirts</li>
          <li>Warm gloves & inner liners</li>
          <li>Woolen hat & sun cap</li>
          <li>Neck gaiter / buff</li>
        </ul>
      </section>

      {/* Footwear */}
      <section>
        <h3 className="text-xl font-semibold mb-4">🥾 Footwear</h3>
        <ul className="list-disc pl-6 space-y-2">
          <li>High-ankle waterproof trekking boots (broken in)</li>
          <li>Spare lightweight shoes or sandals</li>
          <li>Woolen trekking socks (3–4 pairs)</li>
          <li>Gaiters (recommended for snow regions)</li>
        </ul>
      </section>

      {/* Medical */}
      <section>
        <h3 className="text-xl font-semibold mb-4">💊 Medical & Safety</h3>
        <ul className="list-disc pl-6 space-y-2">
          <li>Personal prescription medicines</li>
          <li>Diamox (after doctor consultation)</li>
          <li>Basic first-aid kit</li>
          <li>Water purification tablets</li>
          <li>Sunscreen (SPF 50+) & lip balm</li>
          <li>Altitude sickness awareness</li>
        </ul>
      </section>

      {/* Tools */}
      <section>
        <h3 className="text-xl font-semibold mb-4">🧰 Trekking Gear</h3>
        <ul className="list-disc pl-6 space-y-2">
          <li>Backpack (40–60L)</li>
          <li>Daypack (15–20L)</li>
          <li>Trekking poles</li>
          <li>Headlamp with spare batteries</li>
          <li>Reusable water bottles / hydration bladder</li>
          <li>Sleeping bag (if not provided)</li>
        </ul>
      </section>

      {/* Documents */}
      <section>
        <h3 className="text-xl font-semibold mb-4">📄 Documents</h3>
        <ul className="list-disc pl-6 space-y-2">
          <li>Passport (original)</li>
          <li>Trekking permits (TIMS, National Park)</li>
          <li>Travel insurance (high-altitude coverage)</li>
          <li>Extra passport-size photos</li>
        </ul>
      </section>

      {/* Final Tip */}
      <section className="bg-blue-50 border border-blue-200 rounded-xl p-6">
        <h4 className="font-semibold mb-2">Expert Tip</h4>
        <p>
          Pack light but smart. Layering is key in the Himalayas. Our guides
          will assist you daily to ensure safety, comfort, and acclimatization.
        </p>
      </section>
    </div>
  );
}
